import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { _className, Grid, LL_H_C, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_PopulationEditor } from '../Component_PopulationEditor/Component_PopulationEditor.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DropDown_PrognosisRateType, DropDown_PrognosisValue, } from '../../../_enum.js';
import { PrognosisRateType_Qualitative, PrognosisRateTypeLabelMap, PrognosisValueLabelMap } from '@app/dp-shared';
import './Component_PrognosisItemEditor.scss';
import { DefaultEditor_InputNumeric } from '@app/styles/frontend/ui-manager/ui-components';
import { Dropdown_Timespans, QRangeInputV3 } from '@app/hcs-frontend';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { TimespanLabelsMap } from '@app/hcs-shared';
import { ICONS } from '@app/styles';
const ViewMode_View = 'view';
const ViewMode_Edit = 'edit';
export class Component_PrognosisItemEditor extends TS_EditableItemComponent {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        state.withRemoveIcon = !!nextProps.withRemoveIcon;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    composeRate = () => {
        const prognosis = this.state.editable.item;
        if (!prognosis.rate)
            return;
        if (prognosis.rate?.type === PrognosisRateType_Qualitative)
            return PrognosisValueLabelMap[prognosis.rate.value];
        const percentage = prognosis.rate.value[0] === prognosis.rate.value[1]
            ? `${prognosis.rate.value[0]}%`
            : `${prognosis.rate.value[0]} - ${prognosis.rate.value[1]}%`;
        return `${PrognosisRateTypeLabelMap[prognosis.rate.type]} of ${percentage}`;
    };
    composeTimePeriod = () => {
        const timePeriod = this.state.editable.item.timePeriod;
        if (!timePeriod)
            return;
        return `${timePeriod.value} ${TimespanLabelsMap[timePeriod.type]}`;
    };
    // ######################## Render ########################
    render() {
        const population = this.state.editable.editProp('population', {});
        const className = _className('prognosis-item-editor', this.state.editMode && 'edit-mode');
        return _jsxs(Grid, { className: className, children: [this.renderRate(), this.renderTimePeriod(), _jsx(Component_PopulationEditor, { editable: population, editMode: this.state.editMode }), this.state.editMode && this.state.withRemoveIcon && _jsx(ICONS.bin.component, { onClick: () => this.state.editable.delete() })] });
    }
    // ######################## Render - Rate ########################
    renderRate = () => {
        const editable = this.state.editable;
        const rate = editable.editProp('rate', {});
        return _jsx(TS_PropRenderer.Flat, { label: 'Rate', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'prognosis-item-editor__data span-row', children: this.composeRate() })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsxs(_Fragment, { children: [_jsx(DropDown_PrognosisRateType.editable, { editable: rate, prop: 'type' }), this.renderRateInput()] })
                    }
                ] }) });
    };
    renderRateInput = () => {
        const rate = this.state.editable.editProp('rate', {});
        if (!rate.item.type)
            return;
        if (rate.item.type === PrognosisRateType_Qualitative)
            return _jsx(DropDown_PrognosisValue.editable, { editable: rate, prop: 'value' });
        return this.renderPercentageInput();
    };
    renderPercentageInput = () => {
        const rate = this.state.editable.editProp('rate', {});
        return _jsxs(LL_H_C, { className: 'prognosis-item-editor__percentage-input', children: [_jsx(QRangeInputV3, { editable: rate, prop: 'value' }), _jsx("div", { className: 'prognosis-item-editor__percentage-input__icon', children: "%" })] });
    };
    // ######################## Render - Time Period ########################
    renderTimePeriod = () => {
        const timePeriod = this.state.editable.editProp('timePeriod', {});
        return _jsx(TS_PropRenderer.Flat, { label: 'Time Period', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'prognosis-item-editor__data span-row', children: this.composeTimePeriod() }),
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsxs(_Fragment, { children: [_jsx(Dropdown_Timespans.editable, { editable: timePeriod, prop: 'type' }), _jsx(DefaultEditor_InputNumeric, { editable: timePeriod, prop: 'value' })] })
                    }
                ] }) });
    };
}
//# sourceMappingURL=Component_PrognosisItemEditor.js.map